/** Athlete referral codes (?ref=) shared across T1DW apps. Browser-safe. */
export const ATHLETE_REF_KEY = "t1dw_ref";
export const ATHLETE_REF_TTL_MS = 30 * 24 * 60 * 60 * 1000;

export function normalizeAthleteRef(value: unknown): string | null {
  const v = typeof value === "string" ? value.trim() : "";
  return /^[A-Za-z0-9]{8,16}$/.test(v) ? v : null;
}

type Store = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export function readAthleteRef(store: Store, now = Date.now()): string | null {
  try {
    const raw = store.getItem(ATHLETE_REF_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { ref?: string; expires?: number };
    const ref = normalizeAthleteRef(parsed.ref);
    if (!ref || !parsed.expires || parsed.expires < now) {
      store.removeItem(ATHLETE_REF_KEY);
      return null;
    }
    return ref;
  } catch {
    return null;
  }
}

/** Saves a valid ref for 30 days. Invalid or empty values never overwrite a saved one. */
export function captureAthleteRef(search: string, store: Store, now = Date.now()): void {
  try {
    const ref = normalizeAthleteRef(new URLSearchParams(search).get("ref"));
    if (!ref) return;
    store.setItem(ATHLETE_REF_KEY, JSON.stringify({ ref, expires: now + ATHLETE_REF_TTL_MS }));
  } catch {
    // Storage unavailable; referral tracking is best effort.
  }
}

export function getStoredAthleteRef(): string | null {
  if (typeof window === "undefined") return null;
  return readAthleteRef(window.localStorage);
}
